import { useEffect, useState } from "react";
import axios from "axios";
import { useLang } from "@/context/LanguageContext";
import Reveal from "@/components/Reveal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Bureau = () => {
  const { lang, t } = useLang();
  const [board, setBoard] = useState([]);

  useEffect(() => {
    axios
      .get(`${API}/artists?category=bureau`)
      .then((res) => setBoard(res.data))
      .catch(() => setBoard([]));
  }, []);

  return (
    <section id="bureau" data-testid="bureau-section" className="relative border-y border-gold/15 bg-ink2">
      <div className="mx-auto max-w-[1600px] px-4 py-24 sm:px-8 lg:px-16 lg:py-36">
        <Reveal>
          <p className="font-mono text-[11px] uppercase tracking-[0.35em] text-gold">{t.bureau.kicker}</p>
        </Reveal>
        <div className="mt-4 grid grid-cols-1 gap-10 lg:grid-cols-12">
          <Reveal delay={0.1} className="lg:col-span-5">
            <h2 className="font-serif text-3xl font-light leading-tight text-parchment sm:text-4xl lg:text-5xl">
              {t.bureau.title}
            </h2>
          </Reveal>
          <Reveal delay={0.2} className="lg:col-span-7">
            <p className="max-w-2xl text-base font-light leading-relaxed text-sand sm:text-lg lg:ml-auto">
              {t.bureau.sub}
            </p>
          </Reveal>
        </div>

        <div className="mt-16 flex flex-wrap justify-center gap-6">
          {board.map((member, i) => (
            <Reveal key={member.id} delay={i * 0.1} className="w-full sm:w-[calc(50%-12px)] lg:w-[calc(33.333%-16px)] xl:w-[calc(20%-20px)]">
              <article
                data-testid="board-member-card"
                className="gold-frame group relative h-full overflow-hidden border border-gold/20 bg-card2"
              >
                <div className="relative aspect-[4/5] overflow-hidden">
                  <img
                    src={member.image}
                    alt={member.name}
                    loading="lazy"
                    className="h-full w-full object-cover object-top grayscale-[35%] transition-all duration-700 group-hover:scale-105 group-hover:grayscale-0"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-card2 via-transparent to-transparent" />
                </div>
                <div className="p-5 text-center">
                  <h3 className="font-serif text-xl font-light text-parchment">{member.name}</h3>
                  <p className="mt-2 font-mono text-[9px] uppercase leading-relaxed tracking-[0.2em] text-gold/90">
                    {lang === "fr" ? member.discipline_fr : member.discipline_i18n?.[lang] || member.discipline_en || member.discipline_fr}
                  </p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Bureau;
